import React from 'react';

// Exists to ensure SEO with Next.js Links and accessability, needs a wrap around with a forwardRef functional
// component

const WrappedLink = React.forwardRef(({ className, onClick, href, target, children }, ref) => {
  return (
    <a className={className} href={href} onClick={onClick} target={target} ref={ref}>
      {children}
    </a>
  );
});

WrappedLink.displayName = 'WrappedLink';
export default WrappedLink;
